<template>
    <div class="container">
        <!-- Heading -->
        <h1>{{ formTitle }}</h1>

        <!-- Links -->
        <ul class="links">
            <li>
                <a href="#" @click.prevent="switchTo('signin')">Log in</a>
            </li>
            <li>
                <a href="#" @click.prevent="switchTo('signup')">Sign up</a>
            </li>
            <li>
                <a href="#" @click.prevent="resetForm">RESET</a>
            </li>
        </ul>

        <!-- Form -->
        <form @click.prevent="handleLogin">
            <!-- email input -->
            <div class="first-input input__block"
                :class="{ 'first-input__block': formTitle === 'Log in', 'signup-input__block': formTitle === 'Sign up' }">
                <input type="email" placeholder="Email" class="input" id="email" v-model="email" />
            </div>
            <!-- password input -->
            <div class="input__block">
                <input type="password" placeholder="Password" class="input" id="password" v-model="password" />
            </div>
            <!-- repeat password input -->
            <div class="input__block"
                v-if="formTitle ===  'Sign up'">
                <input type="password" placeholder="Repeat password" class="input repeat__password"
                    id="repeat__password" v-model="repeatPassword" />
            </div>
            <!-- sign in button -->
            <button class="signin__btn" type="submit">{{ buttonText }}</button>
        </form>
        <!-- separator -->
        <div class="separator">
            <p>OR</p>
        </div>
        <!-- google button -->
        <button class="google__btn">
            <i class="fa fa-google"></i>
            Sign in with Google
        </button>
        <!-- google button -->
        <!-- <button class="github__btn">
            <i class="fa fa-github"></i>
            Sign in with GitHub
        </button> -->
    </div>
</template>

<script>
import { login } from '@/scripts/login.js';


export default {
    name: 'Login',
    data() {
        return {
            formTitle: 'Log in',
            email: '',
            password: '',
            repeatPassword: '',
            buttonText: 'Sign in'
        };
    },
    methods: {
        switchTo(formType) {
            if (formType === 'signup') {
                this.formTitle = 'Sign up';
                this.buttonText = 'Sign up';
            } else if (formType === 'signin') {
                this.formTitle = 'Log in';
                this.buttonText = 'Log in';
            }
        },
        resetForm() {
            this.email = '';
            this.password = '';
            this.repeatPassword = '';
        },
        handleLogin() {
            const user = login.find(user => user.userEmail === this.email && user.userPwd === this.password);
            if (user) {
                // 로그인 성공 시 Vuex store의 상태를 변경합니다.
                this.$store.dispatch('handleLogin', { userEmail: this.email });
                console.log('Login successful:', this.email);
                document.cookie = `userEmail=${user.userEmail}; expires=Sun, 1 Jan 2023 00:00:00 UTC; path=/`;
                this.$router.push({ path: '/' }); // Home 페이지로 이동
            } else {
                // 로그인 실패 시 처리
                console.log('Login failed: User information does not match.');
            }
        },
    }
};
</script>
<style scoped>
.container {
    display: block;
    max-width: 680px;
    width: 80%;
    margin: 120px auto;
}

h1 {
    color: #e91e63;
    font-size: 48px;
    letter-spacing: -3px;
    text-align: center;
    margin: 120px 0 80px 0;
    transition: 0.2s linear;
}

.links {
    list-style-type: none;

    li {
        display: inline-block;
        margin: 0 20px 0 0;
        transition: 0.2s linear;

        &:nth-child(2) {
            opacity: 0.6;

            &:hover {
                opacity: 1;
            }
        }

        &:nth-child(3) {
            opacity: 0.6;
            float: right;

            &:hover {
                opacity: 1;
            }
        }

        a {
            text-decoration: none;
            color: #0f132a;
            font-weight: bolder;
            text-align: center;
            cursor: pointer;
        }
    }
}

form {
    width: 100%;
    max-width: 680px;
    margin: 40px auto 10px;

    .input__block {
        margin: 20px auto;
        display: block;
        position: relative;

        &.first-input__block {
            &::before {
                content: "";
                position: absolute;
                top: -15px;
                left: 50px;
                display: block;
                width: 0;
                height: 0;
                background: transparent;
                border-left: 15px solid transparent;
                border-right: 15px solid transparent;
                border-bottom: 15px solid rgba(15, 19, 42, 0.1);
                /* 수정 */
                transition: 0.2s linear;
            }
        }

        &.signup-input__block {
            &::before {
                content: "";
                position: absolute;
                top: -15px;
                left: 150px;
                display: block;
                width: 0;
                height: 0;
                background: transparent;
                border-left: 15px solid transparent;
                border-right: 15px solid transparent;
                border-bottom: 15px solid rgba(15, 19, 42, 0.1);
                /* 수정 */
                transition: 0.2s linear;
            }
        }

        input {
            display: block;
            width: 90%;
            max-width: 680px;
            height: 50px;
            margin: 0 auto;
            border-radius: 8px;
            border: none;
            background: rgba(15, 19, 42, 0.1);
            /* 수정 */
            color: rgba(15, 19, 42, 0.3);
            /* 수정 */
            padding: 0 0 0 15px;
            font-size: 14px;
            font-family: 'Noto Sans KR', sans-serif;

            &:focus,
            &:active {
                outline: none;
                border: none;
                color: rgba(15, 19, 42, 1);
                /* 수정 */
            }

            &.repeat__password {
                transition: 0.2s linear;
            }
        }
    }

    .signin__btn {
        background: #e91e63;
        color: white;
        display: block;
        width: 92.5%;
        max-width: 680px;
        height: 50px;
        border-radius: 8px;
        margin: 0 auto;
        border: none;
        cursor: pointer;
        font-size: 14px;
        font-family: 'Noto Sans KR', sans-serif;
        box-shadow: 0 15px 30px rgba(233, 30, 99, 0.36);
        /* 수정 */
        transition: 0.2s linear;

        &:hover {
            box-shadow: 0 0 0 rgba(233, 30, 99, 0);
            /* 수정 */
        }
    }
}

.separator {
    display: block;
    margin: 30px auto 10px;
    text-align: center;
    height: 40px;
    position: relative;
    background: transparent;
    color: rgba(15, 19, 42, 0.4);
    /* 수정 */
    font-size: 13px;
    width: 90%;
    max-width: 680px;

    &::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 0;
        background: rgba(15, 19, 42, 0.2);
        /* 수정 */
        height: 1px;
        width: 45%;
    }

    &::after {
        content: "";
        position: absolute;
        top: 8px;
        right: 0;
        background: rgba(15, 19, 42, 0.2);
        /* 수정 */
        height: 1px;
        width: 45%;
    }
}

.google__btn,
.github__btn {
    display: block;
    width: 90%;
    max-width: 680px;
    margin: 20px auto;
    height: 50px;
    cursor: pointer;
    font-size: 14px;
    font-family: 'Noto Sans KR', sans-serif;
    border-radius: 8px;
    border: none;
    line-height: 40px;

    &.google__btn {
        background: #5b90f0;
        color: white;
        box-shadow: 0 15px 30px rgba(#5b90f0, .36);
        transition: .2s linear;

        .fa {
            font-size: 20px;
            padding: 0 5px 0 0;
        }

        &:hover {
            box-shadow: 0 0 0 rgba(#5b90f0, .0);
        }
    }

    &.github__btn {
        background: #25282d;
        color: white;
        box-shadow: 0 15px 30px rgba(#25282d, .36);
        transition: .2s linear;

        .fa {
            font-size: 20px;
            padding: 0 5px 0 0;
        }

        &:hover {
            box-shadow: 0 0 0 rgba(#25282d, .0);
        }
    }
}
</style>